module.exports = __webpack_public_path__ + "dist/solution_4.7c92d035.png";